@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.calls

import com.narbase.letsgo.dto.KmmLong
import com.narbase.letsgo.router.EndPoint

object LogVoipCallEndpoint : EndPoint<LogVoipCallEndpoint.Request, LogVoipCallEndpoint.Response>() {
    class Request(
        val callId: KmmLong,
        val status: String,
        val sipCallId: String
    )

    class Response
}

object UpdateVoipCallStatusEndpoint :
    EndPoint<UpdateVoipCallStatusEndpoint.Request, UpdateVoipCallStatusEndpoint.Response>() {
    class Request(
        val callId: KmmLong,
        val status: String
    )

    class Response
}

object KeepVoipCallAliveEndpoint :
    EndPoint<KeepVoipCallAliveEndpoint.Request, KeepVoipCallAliveEndpoint.Response>() {
    class Request(
        val callId: KmmLong
    )

    class Response(
        val isAlive: Boolean
    )
}

object VoipRegistrationReportEndpoint :
    EndPoint<VoipRegistrationReportEndpoint.Request, VoipRegistrationReportEndpoint.Response>() {
    class Request(
        val callId: KmmLong,
        val registrationResponse: String,
        val status: String
    )

    class Response
}
